/**
 *  validations messages
 */
export const validationMessages = {
    name: [{ type: 'required', message: 'User name is required.' }],
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'email', message: 'Invalid Email' },
  
    ],
    password: [
      { type: 'required', message: 'Password is required.' },
      { type: 'minlength', message: 'Password must be at least 8 character long.' },
      { type: 'maxlength', message: 'Maximum 12 character long' },
    ],
  };